import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ADMIN_NAV, UNLISTED_ADMIN_ROUTES } from "../config/adminNav";
import { canOpenAdminRoute, collectAdminRouteRules } from "../helpers/adminNav";
import { AccessDenied } from "./AccessDenied";

const RULES = collectAdminRouteRules(ADMIN_NAV, UNLISTED_ADMIN_ROUTES);

// Wraps every admin route in App.tsx. A route needs the permission of the
// sidebar row it belongs to, so a page the sidebar hides cannot be opened by URL
// either. Without access the page is never rendered, so it fetches nothing.
export const AdminRouteGuard: React.FC = () => {
  const { user, hasPermission } = useAuth();
  const { pathname } = useLocation();

  if (
    !canOpenAdminRoute(
      pathname,
      RULES,
      Boolean(user?.isAdminAccount),
      hasPermission
    )
  ) {
    return <AccessDenied />;
  }

  return <Outlet />;
};
